'use strict';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Pagination } from "semantic-ui-react";
import SelectInput from "./SelectInput";
import Row from "./Row";
import Col from "./Col";

const Table = (props) => {
    const {
        headers,
        headerSizes,
        maxHeight,
        children,
        type,
        style,
        onClickHeader,
        sortableColumns,
        onPageChange,
        pageSize,
        totalPages,
        activePage,
        id,
        changePageSize,
        totalItems,
        title,
        containerMargin,
        setMinWidth
    } = props;

    const tableWrapperStyle = {
        height: maxHeight ? maxHeight : null,
        position: 'relative',
        overflow: 'visible',
        borderLeft: '0',
        borderTop: '0',
        borderRight: '0',
        marginBottom: '0px'
    };

    const tableContainerStyle = {
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto'
    };

    const thInnerStyle = {
        position: 'absolute',
        display: 'block',
        top: 0,
        margin: '4px'
    };

    const headerStyle = {
        minWidth: setMinWidth ? '10rem' : null
    };

    const headerBackgroundStyle = {
        backgroundColor: '#f9f9f9',
        height: '25px',
        'border-top-left-radius': '4px',
        'border-top-right-radius': '4px'
    };

    const pageSizes = [
        { label: "20", value: 20 },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
        { label: "250", value: 250 }
    ];

    function handleOnClickHeader(index) {
        if (sortableColumns && sortableColumns.indexOf(index) >= 0) {
            return function (event) {
                onClickHeader(index, event);
            };
        }
        else {
            return null;
        }
    }

    const paging = () => {
        const currentPageInfo = <Col size={2} style={{ 'color': '#777', 'font-size': '14px' }}>
            {totalItems ?
                <div>{pageSize * (activePage - 1) + 1} tot {(pageSize * activePage) > totalItems ? totalItems : (pageSize * activePage)} van {totalItems}</div>
                : null}
        </Col>;

        return onPageChange && totalPages > 1 ?
            <Row>
                <div className="paging-container">
                    <Col size={3} />
                    <Col size={6} style={{ 'margin-top': '-1px', 'color': '#777', 'font-size': '14px' }}>
                        <Pagination
                            onPageChange={onPageChange}
                            activePage={activePage}
                            totalPages={totalPages}
                            boundaryRange={0}
                            firstItem={activePage === 1 || activePage === 2 ? null : {
                                'aria-label': 'Last item',
                                content: <i className="fa fa-angle-double-left" />
                            }}
                            prevItem={activePage === 1 ? null : {
                                'aria-label': 'Next item',
                                content: <i className="fa fa-caret-left" />
                            }}
                            lastItem={activePage === totalPages || activePage === totalPages - 1 ? null : {
                                'aria-label': 'Last item',
                                content: <i className="fa fa-angle-double-right" />
                            }}
                            nextItem={activePage === totalPages ? null : {
                                'aria-label': 'Next item',
                                content: <i className="fa fa-caret-right" />
                                // style: { 'outline': 'none;' }//todo
                            }}
                        />
                    </Col>
                    <Col size={1} />
                    {currentPageInfo}
                </div>
            </Row> : null;
    };

    const pageSizePicker = changePageSize ?
        <Col size={3}>
            <div style={{ 'text-align': 'center', 'margin-top': '16px', 'color': '#777', 'font-size': '14px', 'float': 'left' }}>Toon</div>
            <div style={{ 'float': 'left' }}>
                <SelectInput
                    items={pageSizes}
                    name="pageSize"
                    defaultItemVisible={false}
                    value={pageSize}
                    onChange={(event) => changePageSize(event.target.value)}
                    superSmall />
            </div>
            <div style={{ 'text-align': 'center', 'margin-top': '16px', 'color': '#777', 'font-size': '14px', 'float': 'left' }}>resultaten</div>
        </Col > : null;

    return (<div style={{ margin: containerMargin ? containerMargin : "0 0 50px 0" }}>
        {title || changePageSize ?
            <Row>
                <Col size={9}>
                    <h1 style={{ 'color': '#39b4e8', 'margin-top': '16px' }} className="o-col-9 c-input">{title}</h1>
                </Col>
                {pageSizePicker}
            </Row> : null
        }

        <Row>
            <div className="c-table-wrapper" style={tableWrapperStyle}>
                <div className="c-table__spacer" style={headerBackgroundStyle}></div>
                <div className="c-table__container" style={tableContainerStyle}>
                    <table id={id} className={"c-table  c-table--scrollable"} style={{ position: 'static' }}>
                        {headers ? <thead>
                            <tr>
                                {headers.map((header, i) => {
                                    return headerSizes.length > 0 ?
                                        (<th style={headerStyle} onClick={handleOnClickHeader(i)} key={i} width={headerSizes[i] + '%'}><span style={thInnerStyle}>{header} {sortableColumns && sortableColumns.indexOf(i) >= 0 ? <i className="fa fa-sort fa-fw" /> : null}</span></th>) :
                                        (<th style={headerStyle} onClick={handleOnClickHeader(i)} key={i}><span style={thInnerStyle}>{header} {sortableColumns && sortableColumns.indexOf(i) >= 0 ? <i className="fa fa-sort fa-fw" /> : null}</span></th>);
                                })}
                            </tr>
                        </thead> : null}
                        <tbody>
                            {children}
                        </tbody>
                    </table>
                </div>
            </div>
        </Row>
        {paging()}
    </div>);

    // return (
    //     <Fragment>
    //         {pageSizePicker}
    //         <Row>
    //             <table id={id} className={"c-table " + type} style={style}>
    //                 {headers ? <thead>
    //                     <tr>
    //                         {headers.map((header, i) => {
    //                             return headerSizes.length > 0 ?
    //                                 (<th onClick={handleOnClickHeader(i)} key={i} width={headerSizes[i] + '%'}>{header} {sortableColumns && sortableColumns.indexOf(i) >= 0 ? <i className="fa fa-sort fa-fw" /> : null}</th>) :
    //                                 (<th onClick={handleOnClickHeader(i)} key={i}>{header} {sortableColumns && sortableColumns.indexOf(i) >= 0 ? <i className="fa fa-sort fa-fw" /> : null}</th>);
    //                         })}
    //                     </tr>
    //                 </thead> : null}
    //                 <tbody>
    //                     {children}
    //                 </tbody>
    //             </table>
    //             {paging()}
    //         </Row>
    //     </Fragment>
    // );
};

Table.defaultProps = {
    type: 'regular',
    headers: [],
    headerSizes: [],
    maxHeight: 0,
    pageSize: 20,
    totalPages: 0,
    currentPage: 1
};

Table.propTypes = {
    headers: PropTypes.array,
    headerSizes: PropTypes.array,
    type: PropTypes.string,
    maxHeight: PropTypes.number,
    children: PropTypes.node,
    style: PropTypes.object,
    onClickHeader: PropTypes.func,
    sortableColumns: PropTypes.array,
    onPageChange: PropTypes.func,
    pageSize: PropTypes.number,
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
    activePage: PropTypes.number,
    id: PropTypes.string,
    changePageSize: PropTypes.func,
    totalItems: PropTypes.number,
    title: PropTypes.string,
    containerMargin: PropTypes.string,
    setMinWidth: PropTypes.bool
};

export default Table;